import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import type { QuestionStatus } from '@/types';

interface StatusBadgeProps {
  status: QuestionStatus | string;
}

const statusConfig: Record<string, { label: string; className: string }> = {
  pending: {
    label: 'Pending',
    className: 'bg-amber-100 text-amber-800 hover:bg-amber-100',
  },
  triaged: {
    label: 'Triaged',
    className: 'bg-blue-100 text-blue-800 hover:bg-blue-100',
  },
  assigned: {
    label: 'Assigned',
    className: 'bg-purple-100 text-purple-800 hover:bg-purple-100',
  },
  answered: {
    label: 'Answered',
    className: 'bg-green-100 text-green-800 hover:bg-green-100',
  },
  sent: {
    label: 'Sent',
    className: 'bg-emerald-100 text-emerald-800 hover:bg-emerald-100',
  },
  rejected: {
    label: 'Rejected',
    className: 'bg-red-100 text-red-800 hover:bg-red-100',
  },
};

export function StatusBadge({ status }: StatusBadgeProps) {
  const config = statusConfig[status] || {
    label: status,
    className: 'bg-gray-100 text-gray-800',
  };

  return (
    <Badge variant="outline" className={cn('border-0', config.className)}>
      {config.label}
    </Badge>
  );
}
